import { Capacitor, registerPlugin } from "@capacitor/core";

// Resolve the bridge by its Capacitor registration name so the web bundle
// never has to resolve or package the local iOS-only Swift dependency.
const ZunoNativePlaces = registerPlugin("ZunoNativePlaces");

export const isNativeIOSPlaces = (platform = Capacitor.getPlatform()) => platform === "ios";

export function createPlacesSessionToken() {
  return `zuno-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export async function nativePlacesAutocomplete(query, center, sessionToken, client = ZunoNativePlaces, platform = Capacitor.getPlatform()) {
  if (!isNativeIOSPlaces(platform)) throw new Error("Native Places is available only on iOS");
  console.info("[ZunoPlaces]", { stage: "PLACES_QUERY", query });
  try {
    const response = await client.autocomplete({
      query,
      sessionToken,
      latitude: Number.isFinite(Number(center?.lat)) ? Number(center.lat) : undefined,
      longitude: Number.isFinite(Number(center?.lng)) ? Number(center.lng) : undefined,
    });
    const predictions = Array.isArray(response?.predictions) ? response.predictions : [];
    console.info("[ZunoPlaces]", { stage: "PLACES_RESULT_COUNT", count: predictions.length });
    return predictions;
  } catch (error) {
    console.error("[ZunoPlaces]", { stage: "PLACES_NATIVE_ERROR", code: error?.code || "unknown", message: error?.message || "unknown" });
    throw error;
  }
}

export async function nativePlaceDetails(placeId, sessionToken, client = ZunoNativePlaces, platform = Capacitor.getPlatform()) {
  if (!isNativeIOSPlaces(platform)) throw new Error("Native Places is available only on iOS");
  try {
    return await client.details({ placeId, sessionToken });
  } catch (error) {
    console.error("[ZunoPlaces]", { stage: "PLACES_DETAILS_ERROR", code: error?.code || "unknown", message: error?.message || "unknown" });
    throw error;
  }
}
